import { Directive, ElementRef, HostListener, Input, Optional } from '@angular/core';
import { TooltipDirective } from '@app/@wchfs-ui';

@Directive({
  selector: '[wchfsTooltipOnOverflow]',
  standalone: true,
})
export class TooltipOnOverflowDirective {
  @Input('wchfsTooltipOnOverflow') tooltipText?: string | null;

  @HostListener('mouseenter')
  onMouseEnter(): void {
    if (!this.tooltipText || !this.tooltip) return;

    const element = this.el.nativeElement;
    const isOverflowing = element.scrollWidth > element.clientWidth;

    if (isOverflowing) {
      this.tooltip.text = this.tooltipText;
      this.tooltip.show();
    } else {
      this.tooltip.hide();
    }
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    if (this.tooltip) this.tooltip.hide();
  }

  constructor(
    private el: ElementRef<HTMLElement>,
    @Optional() private tooltip: TooltipDirective,
  ) {}
}
